module.exports = __webpack_public_path__ + "img/model.690890b.png";